<template>
  <div class="vendor-trends-page">
    <div v-if="!loading">
      <trend-item
        title="Language pairs KPIs"
        v-model="params"
        type="language"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :report-type-list="reportTypeList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
      />
      <trend-item
        title="Industry sectors KPIs"
        v-model="params"
        type="industry"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :report-type-list="reportTypeList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
      />
      <trend-item
        title="Document types KPIs"
        v-model="params"
        type="document"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :report-type-list="reportTypeList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
      />
      <trend-item
        title="QA models KPIs"
        v-model="params"
        type="qa"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :report-type-list="reportTypeList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
      />
      <trend-item
        title="Evaluation methods KPIs"
        v-model="params"
        type="evaluation"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :report-type-list="reportTypeList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
      />
    </div>
    <pre-loader v-else :preloader-status="true" />
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';

export default Vue.extend({
  name: 'DashBoardVendorsTrends',
  components: {
    'pre-loader': () => import('@/components/preloader/index.vue'),
    'trend-item': () => import('./trendsItems/index.vue'),
  },
  data: () => ({
    loading: true,

    textCategoryList: Array(),
    industryFieldList: Array(),
    languagesList: Array(),
    qaMethodsList: Array(),
    qaModelsList: Array(),
    reportTypeList: [{
      Name: 'All',
      type: 'all',
    }, {
      Name: 'Sucessfull',
      type: 'success',
      color: 'green',
    }, {
      Name: 'Failed',
      type: 'fail',
      color: 'red',
    }],

    params: {
      creation_date: Array(),
      industry_field: Array(),
      doc_type: Array(),
      sourceLanguage: null,
      targetLanguage: null,
      lsp: null,
      qaModel: Array(),
      qaMethod: Array(),
      reportType: {
        Name: 'All',
        type: 'all',
      },
    },
  }),
  methods: {
    getFilters() {
      return Promise.all([
        this.$store.dispatch('GET_LANGUAGES').then((data) => {
          this.languagesList = [...data];
          this.languagesList.unshift({
            ID: '',
            LanguageName: ' All',
            CountryISOCode: 'world',
          });
        }),
        this.$store.dispatch('GET_INDUSTRY').then((data) => {
          this.industryFieldList = [...data];
        }),
        this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
          this.textCategoryList = [...data];
        }),
        this.$store.dispatch('GET_QA_METHODS').then((data) => {
          this.qaMethodsList = [...data];
        }),
        Api.getEvaluationMethods().then((resp) => {
          if (resp.data.Status) {
            this.qaModelsList = [...resp.data.Data];
          }
        }),
      ]);
    },
  },
  created() {
    this.getFilters().then(() => {
      this.loading = false;
    });
  },
});
</script>

<style lang="scss">

</style>
